/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'reaction/attack_everyone': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 18.5a.5.5 0 01-.5-.5v-4a.5.5 0 011 0v4a.5.5 0 01-.5.5zM7 8.5a.494.494 0 01-.257-.071l-5-3a.5.5 0 01.514-.858l5 3A.5.5 0 017 8.5zM13 8.5a.503.503 0 01-.43-.243.502.502 0 01.172-.686l5-3a.5.5 0 01.515.858l-5 3A.487.487 0 0113 8.5z"/><path pid="1" d="M10 3.984L15.259 13H4.741L10 3.984M10 2L3 14h14L10 2z"/>'
  }
})
